'use client';

import { Flex, Skeleton } from '@chakra-ui/react';

const ProductGridActionsSkeleton = () => {
  const _mobileFilterAndSort = (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      gap="1rem"
      w="100%"
      display={{ base: 'flex', lg: 'none' }}
    >
      <Skeleton h="42px" w="100%" />
      <Skeleton h="42px" w="100%" />
    </Flex>
  );

  const _desktopFilterAndSort = (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      gap="1rem"
      w="100%"
      display={{ base: 'none', lg: 'flex' }}
    >
      <Flex gap="0.5rem" alignItems="center" h="42px" w="100%">
        <Skeleton h="100%" w="46px" />
        <Skeleton h="100%" w="100px" />
        <Skeleton h="100%" w="100px" />
        <Skeleton h="100%" w="100px" />
      </Flex>
      <Skeleton h="42px" w="100px" />
    </Flex>
  );
  return (
    <>
      {_mobileFilterAndSort}
      {_desktopFilterAndSort}
    </>
  );
};

export default ProductGridActionsSkeleton;
